const Enum = require('./enums');
const MuteButton = require('./MuteButton');
const Button = require('./Button');
const MicrophoneController = require('./MicrophoneController');
const BrowserRequirements = require('./BrowserRequirements');
const ApiDigitaltTilsyn = require('./ApiDigitaltTilsyn');
const KeepAliveController = require('./KeepAliveController');
const UserController = require('./UserController');
const AntiStall = require('./AntiStall');
const Html5Video = require('./Html5Video');
const WaitingController = require('./WaitingController');
const VideoVisibility = require('./VideoVisibility');
const TimerJS = require('./TimerJS');
const LatencyController = require('./LatencyController');
const LatencyWatcher = require('./LatencyWatcher');
const ScheduledRestartController = require('./ScheduledRestartController');
const MediaSource = require('./MediaSource');
const VideoController = require('./VideoController');
const Statuses = require('./Statuses');
const WebsocketStream = require('./WebsocketStream');
/* $REQUIRE_PLUGINS$ */

module.exports = function (args) {
  const inst_muteButton = new MuteButton('muteButton', null);
  const inst_keepAliveButton = new Button('keepAliveButton', null);
  const inst_stopButton = new Button('stopButton', null);
  const inst_microphone = new MicrophoneController('microphone', null);
  const inst_browserRequirements = new BrowserRequirements('browserRequirements', null);
  const inst_api = new ApiDigitaltTilsyn('api', null);
  const inst_keepAliveController = new KeepAliveController('keepAliveController', null);
  const inst_userController = new UserController('userController', null);
  const inst_antiStall = new AntiStall('antiStall', null);
  const inst_video = new Html5Video('video', null);
  const inst_waitingController = new WaitingController('waitingController', null);
  const inst_videoVisibility = new VideoVisibility('videoVisibility', null);
  const inst_playButton = new Button('playButton', null);
  const inst_t = new TimerJS('t', null);
  const inst_latencyController = new LatencyController('latencyController', null);
  const inst_latencyWatcher = new LatencyWatcher('latencyWatcher', null);
  const inst_scheduledRestartController = new ScheduledRestartController('scheduledRestartController', null);
  const inst_mediaSource = new MediaSource('mediaSource', null);
  const inst_videoController = new VideoController('videoController', null);
  const inst_status = new Statuses('status', null);
  const inst_websocketStream = new WebsocketStream('websocketStream', null);
  /* $PLUGINS$ */
  /* Connecting internal ports... */
  inst_muteButton.bus.on('internalPort', (e) => {
    setImmediate(() => {
      e.port = 'internalPort';
      inst_muteButton._receive(e);
    });
  });
  inst_videoVisibility.bus.on('pageVisibilityPort', (e) => {
    setImmediate(() => {
      e.port = 'pageVisibilityPort';
      inst_videoVisibility._receive(e);
    });
  });
  inst_microphone.bus.on('microphone', (e) => {
    setImmediate(() => {
      e.port = 'microphone';
      inst_microphone._receive(e);
    });
  });
  inst_browserRequirements.bus.on('internalPort', (e) => {
    setImmediate(() => {
      e.port = 'internalPort';
      inst_browserRequirements._receive(e);
    });
  });
  inst_mediaSource.bus.on('mediaSourcePort', (e) => {
    setImmediate(() => {
      e.port = 'mediaSourcePort';
      inst_mediaSource._receive(e);
    });
  });
  inst_websocketStream.bus.on('websocketPort', (e) => {
    setImmediate(() => {
      e.port = 'websocketPort';
      inst_websocketStream._receive(e);
    });
  });
  /* Connecting ports... */
  inst_api.bus.on('api', (e) => {
    setImmediate(() => {
      e.port = 'api';
      inst_keepAliveController._receive(e);
    });
  });
  inst_keepAliveController.bus.on('api', (e) => {
    setImmediate(() => {
      e.port = 'api';
      inst_api._receive(e);
    });
  });
  inst_t.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_keepAliveController._receive(e);
    });
  });
  inst_keepAliveController.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_t._receive(e);
    });
  });
  inst_video.bus.on('video', (e) => {
    setImmediate(() => {
      e.port = 'video';
      inst_videoController._receive(e);
    });
  });
  inst_videoController.bus.on('video', (e) => {
    setImmediate(() => {
      e.port = 'video';
      inst_video._receive(e);
    });
  });
  inst_playButton.bus.on('button', (e) => {
    e.port = 'playButton';
    inst_videoController._receive(e);
  });
  inst_videoController.bus.on('playButton', (e) => {
    e.port = 'button';
    inst_playButton._receive(e);
  });
  inst_playButton.bus.on('button', (e) => {
    e.port = 'playButton';
    inst_userController._receive(e);
  });
  inst_userController.bus.on('playButton', (e) => {
    e.port = 'button';
    inst_playButton._receive(e);
  });
  inst_videoController.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_waitingController._receive(e);
    });
  });
  inst_waitingController.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_videoController._receive(e);
    });
  });
  inst_video.bus.on('html5VideoElement', (e) => {
    setImmediate(() => {
      e.port = 'html5VideoElement';
      inst_antiStall._receive(e);
    });
  });
  inst_websocketStream.bus.on('websocket', (e) => {
    setImmediate(() => {
      e.port = 'websocket';
      inst_mediaSource._receive(e);
    });
  });
  inst_mediaSource.bus.on('websocket', (e) => {
    setImmediate(() => {
      e.port = 'websocket';
      inst_websocketStream._receive(e);
    });
  });
  inst_video.bus.on('html5VideoElement', (e) => {
    setImmediate(() => {
      e.port = 'html5VideoElement';
      inst_latencyWatcher._receive(e);
    });
  });
  inst_t.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_antiStall._receive(e);
    });
  });
  inst_antiStall.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_t._receive(e);
    });
  });
  inst_antiStall.bus.on('antistall', (e) => {
    setImmediate(() => {
      e.port = 'antistall';
      inst_latencyController._receive(e);
    });
  });
  inst_latencyController.bus.on('antistall', (e) => {
    setImmediate(() => {
      e.port = 'antistall';
      inst_antiStall._receive(e);
    });
  });
  inst_video.bus.on('waiting', (e) => {
    setImmediate(() => {
      e.port = 'waiting';
      inst_waitingController._receive(e);
    });
  });
  inst_keepAliveController.bus.on('keepalive', (e) => {
    setImmediate(() => {
      e.port = 'keepalive';
      inst_userController._receive(e);
    });
  });
  inst_userController.bus.on('keepalive', (e) => {
    setImmediate(() => {
      e.port = 'keepalive';
      inst_keepAliveController._receive(e);
    });
  });
  inst_websocketStream.bus.on('statusInput', (e) => {
    e.port = 'input';
    inst_status._receive(e);
  });
  inst_websocketStream.bus.on('websocket', (e) => {
    setImmediate(() => {
      e.port = 'websocket';
      inst_videoController._receive(e);
    });
  });
  inst_videoController.bus.on('websocket', (e) => {
    setImmediate(() => {
      e.port = 'websocket';
      inst_websocketStream._receive(e);
    });
  });
  inst_t.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_videoController._receive(e);
    });
  });
  inst_videoController.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_t._receive(e);
    });
  });
  inst_api.bus.on('api', (e) => {
    setImmediate(() => {
      e.port = 'api';
      inst_videoController._receive(e);
    });
  });
  inst_videoController.bus.on('api', (e) => {
    setImmediate(() => {
      e.port = 'api';
      inst_api._receive(e);
    });
  });
  inst_videoController.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_latencyController._receive(e);
    });
  });
  inst_latencyController.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_videoController._receive(e);
    });
  });
  inst_latencyWatcher.bus.on('latency', (e) => {
    setImmediate(() => {
      e.port = 'latency';
      inst_latencyController._receive(e);
    });
  });
  inst_latencyController.bus.on('latency', (e) => {
    setImmediate(() => {
      e.port = 'latency';
      inst_latencyWatcher._receive(e);
    });
  });
  inst_videoController.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_scheduledRestartController._receive(e);
    });
  });
  inst_scheduledRestartController.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_videoController._receive(e);
    });
  });
  inst_video.bus.on('video', (e) => {
    setImmediate(() => {
      e.port = 'video';
      inst_muteButton._receive(e);
    });
  });
  inst_muteButton.bus.on('video', (e) => {
    setImmediate(() => {
      e.port = 'video';
      inst_video._receive(e);
    });
  });
  inst_keepAliveButton.bus.on('button', (e) => {
    e.port = 'keepAliveButton';
    inst_userController._receive(e);
  });
  inst_userController.bus.on('keepAliveButton', (e) => {
    e.port = 'button';
    inst_keepAliveButton._receive(e);
  });
  inst_latencyController.bus.on('statusInput', (e) => {
    e.port = 'input';
    inst_status._receive(e);
  });
  inst_status.bus.on('wslog', (e) => {
    setImmediate(() => {
      e.port = 'log';
      inst_websocketStream._receive(e);
    });
  });
  inst_waitingController.bus.on('restartScheduler', (e) => {
    setImmediate(() => {
      e.port = 'controllers';
      inst_scheduledRestartController._receive(e);
    });
  });
  inst_t.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_latencyWatcher._receive(e);
    });
  });
  inst_latencyWatcher.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_t._receive(e);
    });
  });
  inst_t.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_scheduledRestartController._receive(e);
    });
  });
  inst_scheduledRestartController.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_t._receive(e);
    });
  });
  inst_mediaSource.bus.on('mediaSource', (e) => {
    setImmediate(() => {
      e.port = 'mediaSource';
      inst_videoController._receive(e);
    });
  });
  inst_videoController.bus.on('mediaSource', (e) => {
    setImmediate(() => {
      e.port = 'mediaSource';
      inst_mediaSource._receive(e);
    });
  });
  inst_video.bus.on('html5VideoElement', (e) => {
    setImmediate(() => {
      e.port = 'html5VideoElement';
      inst_mediaSource._receive(e);
    });
  });
  inst_stopButton.bus.on('button', (e) => {
    e.port = 'stopButton';
    inst_userController._receive(e);
  });
  inst_userController.bus.on('stopButton', (e) => {
    e.port = 'button';
    inst_stopButton._receive(e);
  });
  inst_mediaSource.bus.on('statusInput', (e) => {
    e.port = 'input';
    inst_status._receive(e);
  });
  inst_videoController.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_userController._receive(e);
    });
  });
  inst_userController.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_videoController._receive(e);
    });
  });
  inst_scheduledRestartController.bus.on('statusInput', (e) => {
    e.port = 'input';
    inst_status._receive(e);
  });
  inst_latencyController.bus.on('restartScheduler', (e) => {
    setImmediate(() => {
      e.port = 'controllers';
      inst_scheduledRestartController._receive(e);
    });
  });
  inst_api.bus.on('statusInput', (e) => {
    e.port = 'input';
    inst_status._receive(e);
  });
  inst_stopButton.bus.on('button', (e) => {
    e.port = 'stopButton';
    inst_videoController._receive(e);
  });
  inst_videoController.bus.on('stopButton', (e) => {
    e.port = 'button';
    inst_stopButton._receive(e);
  });
  inst_videoController.bus.on('statusInput', (e) => {
    e.port = 'input';
    inst_status._receive(e);
  });
  inst_keepAliveButton.bus.on('button', (e) => {
    e.port = 'keepAliveButton';
    inst_keepAliveController._receive(e);
  });
  inst_keepAliveController.bus.on('keepAliveButton', (e) => {
    e.port = 'button';
    inst_keepAliveButton._receive(e);
  });
  inst_t.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_microphone._receive(e);
    });
  });
  inst_microphone.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_t._receive(e);
    });
  });
  inst_waitingController.bus.on('statusInput', (e) => {
    e.port = 'input';
    inst_status._receive(e);
  });
  inst_latencyWatcher.bus.on('statusInput', (e) => {
    e.port = 'input';
    inst_status._receive(e);
  });
  inst_video.bus.on('statusInput', (e) => {
    e.port = 'input';
    inst_status._receive(e);
  });
  inst_videoController.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_videoVisibility._receive(e);
    });
  });
  inst_videoVisibility.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_videoController._receive(e);
    });
  });
  inst_t.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_websocketStream._receive(e);
    });
  });
  inst_websocketStream.bus.on('timer', (e) => {
    setImmediate(() => {
      e.port = 'timer';
      inst_t._receive(e);
    });
  });
  inst_videoController.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_muteButton._receive(e);
    });
  });
  inst_muteButton.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_videoController._receive(e);
    });
  });
  inst_videoController.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_keepAliveController._receive(e);
    });
  });
  inst_keepAliveController.bus.on('videoControl', (e) => {
    setImmediate(() => {
      e.port = 'videoControl';
      inst_videoController._receive(e);
    });
  });
  inst_keepAliveController.bus.on('keepalive', (e) => {
    setImmediate(() => {
      e.port = 'keepalive';
      inst_scheduledRestartController._receive(e);
    });
  });
  inst_scheduledRestartController.bus.on('keepalive', (e) => {
    setImmediate(() => {
      e.port = 'keepalive';
      inst_keepAliveController._receive(e);
    });
  });
  inst_microphone.MicrophoneController_tone_var = require('tone');
  inst_microphone.MicrophoneController_client_var = args.clientApiDigitaltTilsyn;
  inst_microphone.MicrophoneController_apiURL_var = args.apiURL;
  inst_microphone.MicrophoneController_serial_var = args.name;
  inst_microphone.MicrophoneController_cameraId_var = args.cameraId;
  inst_microphone.MicrophoneController_timerId_var = 123;
  inst_microphone.MicrophoneController_stream_var = null;
  inst_microphone.MicrophoneController_audioContext_var = null;
  inst_microphone.MicrophoneController_audioProcessor_var = null;
  inst_microphone.MicrophoneController_audioSource_var = null;
  inst_microphone.MicrophoneController_workletUrl_var = null;
  inst_microphone.MicrophoneController_toneGenerator_var = null;
  inst_microphone.MicrophoneController_bufferTimeInMs_var = 250;
  inst_microphone.MicrophoneController_audioMessageBuffer_var = new Uint8Array();
  inst_microphone.MicrophoneController_audioHash_var = '';
  inst_microphone.MicrophoneController_MAX_BUFFER_SIZE_var = 1024 * 1024;
  inst_microphone.MicrophoneController_startToneTimeout_var = 1650;
  inst_microphone.MicrophoneController_closingToneTimeout_var = 1450;
  inst_microphone.MicrophoneController_maxRecordingTime_var = 15000;
  inst_microphone.MicrophoneController_toneVolume_var = 0.15;

  inst_api.ApiDigitaltTilsyn_client_var = args.clientApiDigitaltTilsyn;

  inst_keepAliveController.KeepAliveController_defaultKeepAliveTtl_var = 86400;
  inst_keepAliveController.KeepAliveController_timeLeftBeforeWarning_var = 60000;
  inst_keepAliveController.KeepAliveController_shortTimeLeftTimerId_var = 70;
  inst_keepAliveController.KeepAliveController_tickTackTimerId_var = 71;
  inst_keepAliveController.KeepAliveController_currentTTL_var = -1;
  inst_keepAliveController.KeepAliveController_currentStreamId_var = '';
  inst_keepAliveController.KeepAliveController_currentCameraId_var = '';
  inst_keepAliveController.KeepAliveController_timeWhenCurrentTTLIsReceived_var = -1;
  inst_keepAliveController.KeepAliveController_null_Warning_WarningTickTack_secondsLeft_var = 0;

  inst_antiStall.AntiStall_video_var = undefined;
  inst_antiStall.AntiStall_workTimerId_var = 100;
  inst_antiStall.AntiStall_checkIntervalMs_var = 10000;
  inst_antiStall.AntiStall_null_Check_videoData_var = undefined;
  inst_antiStall.AntiStall_null_Check_currentTime_var = 0;

  inst_video.Html5Video_tokenMode_var = args.tokenMode === true;
  inst_video.Html5Video_video_var = undefined;
  inst_video.Html5Video_videoContainer_var = args.videoContainer;
  inst_video.Html5Video_videoContainerId_var = args.videoContainerId;
  inst_video.Html5Video_cameraId_var = args.cameraId;
  inst_video.Html5Video_userWantsSound_var = !!args.userWantsSound;
  inst_video.Html5Video_client_var = args.clientApiDigitaltTilsyn;
  inst_video.Html5Video_metricsSent_var = false;
  inst_video.Html5Video_waiting_var = false;
  inst_video.Html5Video_waitingSince_var = 0;
  inst_video.Html5Video_currentRatio_var = -1;
  inst_video.Html5Video_null_needsFullReset_var = inst_video.isInternetExplorer();
  inst_video.Html5Video_null_Initialize_startedAt_var = 0;

  inst_waitingController.WaitingController_accumulatedWaiting_var = 0;
  inst_waitingController.WaitingController_maxAccumulatedWaiting_var = 30000;

  inst_t.TimerJS_Timeouts_var = new Map();

  inst_latencyWatcher.LatencyWatcher_video_var = undefined;
  inst_latencyWatcher.LatencyWatcher_workTimerId_var = 80;
  inst_latencyWatcher.LatencyWatcher_bufferedTime_var = 0;
  inst_latencyWatcher.LatencyWatcher_currentTime_var = 0;
  inst_latencyWatcher.LatencyWatcher_latency_var = 0;
  inst_latencyWatcher.LatencyWatcher_maxLatency_var = 10;
  inst_latencyWatcher.LatencyWatcher_highLatencyGauge_var = 0;
  inst_latencyWatcher.LatencyWatcher_maxLatencyGague_var = 3;

  inst_scheduledRestartController.ScheduledRestartController_gracePeriod_var = 5000;
  inst_scheduledRestartController.ScheduledRestartController_maxGracePeriod_var = 60000;
  inst_scheduledRestartController.ScheduledRestartController_scheduledRestartControllerTimerId_var = 110;
  inst_scheduledRestartController.ScheduledRestartController_maxAutoRestartCount_var = 16;
  inst_scheduledRestartController.ScheduledRestartController_autoRestartCount_var = 0;
  inst_scheduledRestartController.ScheduledRestartController_autoRestartEnabled_var = true;
  inst_scheduledRestartController.ScheduledRestartController_keepAliveWarning_var = false;

  inst_mediaSource.MediaSource_video_var = undefined;
  inst_mediaSource.MediaSource_client_var = args.clientApiDigitaltTilsyn;
  inst_mediaSource.MediaSource_secondsToKeep_var = 60;
  inst_mediaSource.MediaSource_maxUpdatesWithoutRemovingOldVideo_var = 100;
  inst_mediaSource.MediaSource_sourceFormat_var = '';
  inst_mediaSource.MediaSource_mediaSource_var = undefined;
  inst_mediaSource.MediaSource_sourceBuffer_var = undefined;
  inst_mediaSource.MediaSource_fifo_var = [];
  inst_mediaSource.MediaSource_null_Connected_Setup_startedAt_var = 0;
  inst_mediaSource.MediaSource_null_Connected_Playing_updatesWithoutRemovingOldVideo_var = 0;
  inst_mediaSource.MediaSource_null_Connected_Playing_RemovingOldVideo_hadToRemoveVideo_var = false;

  inst_videoController.VideoController_defaultProfile_var = 'Standard';
  inst_videoController.VideoController_defaultTtl_var = 86400;
  inst_videoController.VideoController_maxStartingTime_var = 45000;
  inst_videoController.VideoController_errorRetryDelay_var = 1250;
  inst_videoController.VideoController_maxErrorRetryDelay_var = 30000;
  inst_videoController.VideoController_startingMainTimerId_var = 10;
  inst_videoController.VideoController_errorTimerId_var = 11;
  inst_videoController.VideoController_streamId_var = '';
  inst_videoController.VideoController_cameraId_var = args.cameraId;
  inst_videoController.VideoController_null_Starting_startedAt_var = 0;

  inst_status.Statuses_userAgent_var = window.navigator.userAgent;
  inst_status.Statuses_healthProviderId_var = args.healthProviderId;
  inst_status.Statuses_cameraName_var = args.name;

  const inst_websocketStream_pendingLogs = [];
  inst_websocketStream.WebsocketStream_pendingLogs_var = inst_websocketStream_pendingLogs;
  inst_websocketStream.WebsocketStream_client_var = args.clientApiDigitaltTilsyn;
  inst_websocketStream.WebsocketStream_startingTimeoutTimerId_var = 200;
  inst_websocketStream.WebsocketStream_firstMessageTimeoutTimerId_var = 201;
  inst_websocketStream.WebsocketStream_maxWaitDelay_var = 30000;
  inst_websocketStream.WebsocketStream_initialWaitDelay_var = 3750;
  inst_websocketStream.WebsocketStream_waitDelay_var = 3750;
  inst_websocketStream.WebsocketStream_streamURL_var = '';
  inst_websocketStream.WebsocketStream_websocket_var = null;
  inst_websocketStream.WebsocketStream_pendingLogs_var = [];
  inst_websocketStream.WebsocketStream_null_WaitForFirstMessage_startedAt_var = 0;
  inst_websocketStream.WebsocketStream_null_Starting_startedAt_var = 0;

  /* $PLUGINS_CONNECTORS$ */
  inst_t._init();
  inst_websocketStream._init();
  inst_status._init();
  inst_video._init();
  inst_playButton._init();
  inst_api._init();
  inst_mediaSource._init();
  inst_stopButton._init();
  inst_videoController._init();
  inst_muteButton._init();
  inst_keepAliveButton._init();
  inst_microphone._init();
  inst_browserRequirements._init();
  inst_keepAliveController._init();
  inst_userController._init();
  inst_antiStall._init();
  inst_scheduledRestartController._init();
  inst_waitingController._init();
  inst_videoVisibility._init();
  inst_latencyWatcher._init();
  inst_latencyController._init();
  /* $PLUGINS_END$ */

  function terminate() {
    inst_latencyController._stop();
    inst_latencyController._delete();
    inst_latencyWatcher._stop();
    inst_latencyWatcher._delete();
    inst_videoVisibility._stop();
    inst_videoVisibility._delete();
    inst_waitingController._stop();
    inst_waitingController._delete();
    inst_scheduledRestartController._stop();
    inst_scheduledRestartController._delete();
    inst_antiStall._stop();
    inst_antiStall._delete();
    inst_userController._stop();
    inst_userController._delete();
    inst_keepAliveController._stop();
    inst_keepAliveController._delete();
    inst_browserRequirements._stop();
    inst_browserRequirements._delete();
    inst_microphone._stop();
    inst_microphone._delete();
    inst_keepAliveButton._stop();
    inst_keepAliveButton._delete();
    inst_muteButton._stop();
    inst_muteButton._delete();
    inst_videoController._stop();
    inst_videoController._delete();
    inst_stopButton._stop();
    inst_stopButton._delete();
    inst_mediaSource._stop();
    inst_mediaSource._delete();
    inst_api._stop();
    inst_api._delete();
    inst_playButton._stop();
    inst_playButton._delete();
    inst_video._stop();
    inst_video._delete();
    inst_status._stop();
    inst_status._delete();
    inst_websocketStream._stop();
    inst_websocketStream._delete();
    inst_t._stop();
    inst_t._delete();
  };
  return {
    terminate,
    instances: {
      latencyController: inst_latencyController,
      latencyWatcher: inst_latencyWatcher,
      videoVisibility: inst_videoVisibility,
      waitingController: inst_waitingController,
      scheduledRestartController: inst_scheduledRestartController,
      antiStall: inst_antiStall,
      userController: inst_userController,
      keepAliveController: inst_keepAliveController,
      browserRequirements: inst_browserRequirements,
      microphone: inst_microphone,
      keepAliveButton: inst_keepAliveButton,
      muteButton: inst_muteButton,
      videoController: inst_videoController,
      stopButton: inst_stopButton,
      mediaSource: inst_mediaSource,
      api: inst_api,
      playButton: inst_playButton,
      video: inst_video,
      status: inst_status,
      websocketStream: inst_websocketStream,
      t: inst_t,
    },
  };
};
